import { Component, Input,OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { $DBManagerService } from 'src/app/_helpers/DB/DBManager.service';
import { $ModalManagerService } from 'src/app/_helpers/Modals/ModalManager.service';
import { APIIPRegisterService } from '../../_services/ip-register/API-ipregister';

@Component({
  selector: 'app-paymentreceipt',
  templateUrl: './paymentreceipt.component.html',
  styleUrls: ['./paymentreceipt.component.css']
})
export class PaymentreceiptComponent implements OnInit {

  @Input("data") receipt:any
  constructor(private db: $DBManagerService,
    private $modal: $ModalManagerService,
    private ip: APIIPRegisterService,
    private router: Router) { }

  ngOnInit() {
  }
  gotoDuesPage() {
    this.router.navigate(['payment-dues'])
  }

}


